module.exports = __webpack_public_path__ + "assets/media/user-member-lovel03.bd4a5a70.png";